export default {
    methods: {
        
        buildParameters (params) {
            const newParams = Object.assign({}, params)
            newParams.advanced = encodeURIComponent(JSON.stringify(newParams.advanced))
            return newParams;
        },
        
        setParameters (params) {       
            params = this.buildParameters(params);
            this.$router.push({ query: params });
        },
        
        getParameters () {
            
            var query = this.$route.query;
            
            /// Check query
            var params = {};
            params.page = parseInt(query.page || 1);
            params.perPage = parseInt(query.perPage || 15);
            params.orderBy = query.orderBy;
            params.orderDirection = query.orderDirection;
            params.mine = parseInt(query.mine || 0);
            params.query = query.query;
            params.tag = query.tag || null;

            if (query.advanced) {
                params.advanced = JSON.parse(decodeURIComponent(query.advanced));         
            }
            else {
                params.advanced = {};
            }

            return params;
        },
        
        postParameters (path, params, token) {
            params = this.buildParameters(params);
            params["Authorization"] = "Bearer " + token;
            
            // The rest of this code assumes you are not using a library.
            // It can be made less wordy if you use one.
            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", path);
        
            for(var key in params) {
                if(params.hasOwnProperty(key) && params[key] != null) {
                    var hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", params[key]);
        
                    form.appendChild(hiddenField);
                 }
            }
            document.body.appendChild(form);
            form.submit();
        }
    }
}
